import React from "react";
// import TmsReload from "../tms-reload/tms-reload";
import { notification } from "antd";
// import CommsService from "../services/sd-comms.service";
class TmsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: "" };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  async componentDidCatch(error, errorInfo) {
    console.log({ error, errorInfo });
    notification.error(error?.message ?? error);
  }

  render() {
    return this.props.children;
  }
}
export default TmsErrorBoundary;
